
export default {

  props: {
    payment: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      paymentSlug: ``,
    };
  },
  computed: {
    linkSlug () {
      return this.paymentSlug[0] ? this.paymentSlug[0].slug : ``;
    },
  },
  mounted () {
    this.getSlug();
  },
  methods: {
    async getSlug () {
      const queryParams = {
        fields: `id,title,acf,slug,type`,
        posts: {
          post_type: `page`,
          posts_per_page: 1,
          p: this.payment.button.internal_link.ID,
        },
        options: {
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.paymentSlug = request;
      }
    },
  },
};
